import React, { useState, useRef } from "react";
import SoftRecordUX2 from "./SoftRecordUX2";
import { Button, Icon, Modal, Form } from "semantic-ui-react";
import ModalEditImage from "react-lib/apps/common/ModalEditImage";
import SoftTissueExamUX from "../SoftTissueExamUX";
import ModifiedMallampati from "./ModifiedMallampati";
import ExaminationImageOverlay, { Tooltip } from "./ExaminationImageOverlay";
import { getClinicalTagColor, getClinicalTagMergeColor } from "./FaceRecord";

const SOFT = "Oral cavity";

const SoftRecord = (props) => {
  const [openGallery, setOpenGallery] = useState(false);
  const [openPhysicalExam, setOpenPhysicalExam] = useState(false);
  let tooltipRef = useRef() as any;

  const handleClick = (key) => () => {
    console.log("handleClick key: ", key);
    if (props.selectorMode) {
      const organMaster = props.masterData?.organ?.items.filter((item) => item.hasOwnProperty("settingKey"));
      // console.log(" handleClick organMaster ", organMaster)
      let organ = organMaster.filter((item) => item.settingKey === key);
      // console.log(" handleClick organ ", organ)

      if (organ.length === 1) {
        props.onEvent({ message: "ToggleLocation", params: { items: [{ location: organ[0].nickName }] } });
      } else {
        console.log(" should not see me.");
      }
    }
  };

  const handleMouseOver = (e: any, key: string) => {
    tooltipRef?.show?.({
      target: e.target,
      key,
      masterData: props.masterData,
      selector: ".box-soft-mouth-area.svg-zoom-out",
    });
  };

  const handleMouseLeave = () => {
    tooltipRef.current.style.display = "none";
  };

  let settings = Object.assign({}, defaultSettings);
  const clinicalTagsItems = props.masterData.clinicaltags?.items;
  const organMaster = props.masterData?.organ?.items.filter((item) => item.hasOwnProperty("settingKey"));
  const clinical = props.clinicalFindings.find((item) => item.id === props.clinicalFindingId);
  const targetLocation = clinical?.location?.split(",").map((item) => item.trim()) || [];
  const targetClinicaltags = clinical?.clinicaltags?.split(",").map((item) => item.trim()) || [];
  const findClinicalTag = clinicalTagsItems?.find((data) => targetClinicaltags.includes(data.name) && data.diagram === "noteeth");
  let previousList: any[] = [];

  // console.log("OrganMaster ", organMaster)
  for (const item of props.clinicalFindings) {
    let locationList = item?.location?.split(",").map((item) => item.trim()) || [];
    let clinicaltagsList = item?.clinicaltags?.split(",").map((item) => item.trim()) || [];

    for (const keyNickName of locationList) {
      let organ = organMaster.filter((item) => item.nickName === keyNickName);
      // if (Object.keys(defaultSettings).includes(key)) {
      if (organ?.length > 0) {
        organ.forEach((element) => {
          let color = "transparent";
          //key ตรงกับ clinical ที่ active อยู่
          console.log("findClinicaltags", findClinicalTag, targetClinicaltags);

          if (findClinicalTag && targetLocation?.includes(keyNickName)) {
            // color = findClinicalTag.color[0];
            color = getClinicalTagColor(clinicalTagsItems, targetClinicaltags);
          } else if (targetLocation?.includes(keyNickName)) {
            color = "orange";
          }

          if (!props.clinicalFindingId) {
            const findClinicaltags = clinicalTagsItems?.find((data: any) => clinicaltagsList.includes(data.name) && data.diagram === "noteeth");

            if (findClinicaltags) {
              const data = getClinicalTagMergeColor({
                clinicalTagsItems,
                clinicaltagsList,
                previousList,
                findClinicaltags,
                keyNickName,
                color,
              });

              color = data.color;
              previousList = data.previousList;
            } else if (locationList?.includes(keyNickName)) {
              color = "orange";
            }
          }

          settings[element.settingKey] = {
            ...settings[element.settingKey],
            fill: color,
            opacity: "0.7",
          };
        });
      }
      // }
    }
  }

  for (const key in defaultSettings) {
    if (Object.prototype.hasOwnProperty.call(defaultSettings, key)) {
      settings[key] = {
        ...settings[key],
        onClick: handleClick(key),
        style: { pointerEvents: "auto" },
        onMouseOver: (e) => {
          handleMouseOver(e, key);
        },
        onMouseLeave: (e) => {
          handleMouseLeave(e, key);
        },
      };
    }
  }

  // console.log("settings", settings, props.masterData);

  return (
    <div
      // className="soft-area"
      style={{ ...{ cursor: props.selectorMode ? "cell" : "default" }, padding: "0px 0px", display: "flex", flexDirection: "column", alignItems: "center" }}
      onMouseDown={(e: any) => {
        if (props.selectorMode) {
          e.preventDefault();
        }
      }}
    >
      <Form className="box-soft-mouth-area svg-zoom-out">
        <div className="soft-mouth-area">
          <ExaminationImageOverlay
            imageKey="soft"
            sub={props.sub}
            historyReviewSubTab={props.historyReviewSubTab}
            clinicalFindings={props.clinicalFindings}
            filterClinicalFindingIds={props.filterClinicalFindingIds}
            showDrawingChecked={props.showDrawingChecked}
            hideTooltip={true}
            firstPosition={true}
          >
            <SoftRecordUX2 settings={settings} />
          </ExaminationImageOverlay>
        </div>
      </Form>

      <Tooltip ref={(ref) => (tooltipRef = ref || { current: null })} />

      <ModifiedMallampati hiddenEvaluation={props.hiddenEvaluation ? props.hiddenEvaluation : false} />

      {props.activeEvaluation ? (
        <Modal
          onClose={() => props.setProp("activeEvaluation", "")}
          // onOpen={() => setOpenPhysicalExam(true)}
          style={{ width: "80%" }}
          open={props.activeEvaluation === SOFT}
        >
          {" "}
          <SoftTissueExamUX
            softTissueExamData={props.softTissueExamData}
            onEvent={props.onEvent}
            setProp={props.setProp}
            handleSaveSoftTissueExam={() => {
              props.onEvent({ message: "SaveEvaluationForm", params: { form: "softTissueExamData" } });
              // props.setProp("softTissueExamData", {})
              props.setProp("activeEvaluation", "");
            }}
          />{" "}
        </Modal>
      ) : null}
    </div>
  );
};

export default SoftRecord;

const defaultSettings = {
  soft1: { fill: "transparent", stroke: "green" },
  soft2: { fill: "transparent", stroke: "green" },
  soft3: { fill: "transparent", stroke: "green" },
  soft4: { fill: "transparent", stroke: "green" },
  soft5: { fill: "transparent", stroke: "green" },
  soft6: { fill: "transparent", stroke: "green" },
  soft7: { fill: "transparent", stroke: "green" },
  soft8: { fill: "transparent", stroke: "green" },
  soft9: { fill: "transparent", stroke: "green" },
  soft10: { fill: "transparent", stroke: "green" },
  soft11: { fill: "transparent", stroke: "green" },
  soft12: { fill: "transparent", stroke: "green" },
  soft13: { fill: "transparent", stroke: "green" },
  soft14: { fill: "transparent", stroke: "green" },
  soft15: { fill: "transparent", stroke: "green" },
  soft16: { fill: "transparent", stroke: "green" },
  soft17: { fill: "transparent", stroke: "green" },
  soft18: { fill: "transparent", stroke: "green" },
  soft19: { fill: "transparent", stroke: "green" },
  soft20: { fill: "transparent", stroke: "green" },
  soft21: { fill: "transparent", stroke: "green" },
  soft22: { fill: "transparent", stroke: "green" },
  soft23: { fill: "transparent", stroke: "green" },
  soft24: { fill: "transparent", stroke: "green" },
  soft25: { fill: "transparent", stroke: "green" },
  soft26: { fill: "transparent", stroke: "green" },
  soft27: { fill: "transparent", stroke: "green" },
  soft28: { fill: "transparent", stroke: "green" },
  soft29: { fill: "transparent", stroke: "green" },
  soft30: { fill: "transparent", stroke: "green" },
  soft31: { fill: "transparent", stroke: "green" },
  soft32: { fill: "transparent", stroke: "green" },
  soft33: { fill: "transparent", stroke: "green" },
  soft34: { fill: "transparent", stroke: "green" },
  soft35: { fill: "transparent", stroke: "green" },
  soft36: { fill: "transparent", stroke: "green" },
  soft37: { fill: "transparent", stroke: "green" },
  soft38: { fill: "transparent", stroke: "green" },
  soft39: { fill: "transparent", stroke: "green" },
  soft40: { fill: "transparent", stroke: "green" },
  soft41: { fill: "transparent", stroke: "green" },
  soft42: { fill: "transparent", stroke: "green" },
  soft43: { fill: "transparent", stroke: "green" },
  soft44: { fill: "transparent", stroke: "green" },
  soft45: { fill: "transparent", stroke: "green" },
  soft46: { fill: "transparent", stroke: "green" },
  soft47: { fill: "transparent", stroke: "green" },
  soft48: { fill: "transparent", stroke: "green" },
  soft49: { fill: "transparent", stroke: "green" },
  soft50: { fill: "transparent", stroke: "green" },
  soft51: { fill: "transparent", stroke: "green" },
  soft52: { fill: "transparent", stroke: "green" },
  soft53: { fill: "transparent", stroke: "green" },
  soft54: { fill: "transparent", stroke: "green" },
  soft55: { fill: "transparent", stroke: "green" },
  soft56: { fill: "transparent", stroke: "green" },
  soft57: { fill: "transparent", stroke: "green" },
  soft58: { fill: "transparent", stroke: "green" },
  soft59: { fill: "transparent", stroke: "green" },
  soft60: { fill: "transparent", stroke: "green" },
  soft61: { fill: "transparent", stroke: "green" },
  soft62: { fill: "transparent", stroke: "green" },
  soft63: { fill: "transparent", stroke: "green" },
  soft64: { fill: "transparent", stroke: "green" },
  soft65: { fill: "transparent", stroke: "green" },
  soft66: { fill: "transparent", stroke: "green" },
  soft67: { fill: "transparent", stroke: "green" },
  soft68: { fill: "transparent", stroke: "green" },
  soft69: { fill: "transparent", stroke: "green" },
  soft70: { fill: "transparent", stroke: "green" },
  soft71: { fill: "transparent", stroke: "green" },
  soft72: { fill: "transparent", stroke: "green" },
  soft73: { fill: "transparent", stroke: "green" },
  soft74: { fill: "transparent", stroke: "green" },
  soft75: { fill: "transparent", stroke: "green" },
  soft76: { fill: "transparent", stroke: "green" },
  soft77: { fill: "transparent", stroke: "green" },
  soft78: { fill: "transparent", stroke: "green" },
  soft79: { fill: "transparent", stroke: "green" },
  soft80: { fill: "transparent", stroke: "green" },
  soft81: { fill: "transparent", stroke: "green" },
  soft82: { fill: "transparent", stroke: "green" },
  soft83: { fill: "transparent", stroke: "green" },
  soft84: { fill: "transparent", stroke: "green" },
  soft85: { fill: "transparent", stroke: "green" },
  soft86: { fill: "transparent", stroke: "green" },
  soft87: { fill: "transparent", stroke: "green" },
  soft88: { fill: "transparent", stroke: "green" },
  soft89: { fill: "transparent", stroke: "green" },
  soft90: { fill: "transparent", stroke: "green" },
  soft91: { fill: "transparent", stroke: "green" },
  soft92: { fill: "transparent", stroke: "green" },
  soft93: { fill: "transparent", stroke: "green" },
  soft94: { fill: "transparent", stroke: "green" },
  soft95: { fill: "transparent", stroke: "green" },
  soft96: { fill: "transparent", stroke: "green" },
  soft97: { fill: "transparent", stroke: "green" },
  soft98: { fill: "transparent", stroke: "green" },
  soft99: { fill: "transparent", stroke: "green" },
  soft100: { fill: "transparent", stroke: "green" },
  soft101: { fill: "transparent", stroke: "green" },
  soft102: { fill: "transparent", stroke: "green" },
  soft103: { fill: "transparent", stroke: "green" },
  soft104: { fill: "transparent", stroke: "green" },
  soft105: { fill: "transparent", stroke: "green" },
  soft106: { fill: "transparent", stroke: "green" },
  soft107: { fill: "transparent", stroke: "green" },
  soft108: { fill: "transparent", stroke: "green" },
  soft109: { fill: "transparent", stroke: "green" },
  soft110: { fill: "transparent", stroke: "green" },
  soft111: { fill: "transparent", stroke: "green" },
  soft112: { fill: "transparent", stroke: "green" },
  soft113: { fill: "transparent", stroke: "green" },
  soft114: { fill: "transparent", stroke: "green" },
  soft115: { fill: "transparent", stroke: "green" },
  soft116: { fill: "transparent", stroke: "green" },
  soft117: { fill: "transparent", stroke: "green" },
  soft118: { fill: "transparent", stroke: "green" },
  soft119: { fill: "transparent", stroke: "green" },
  soft120: { fill: "transparent", stroke: "green" },
  soft121: { fill: "transparent", stroke: "green" },
  soft122: { fill: "transparent", stroke: "green" },
  soft123: { fill: "transparent", stroke: "green" },
  soft124: { fill: "transparent", stroke: "green" },
  soft125: { fill: "transparent", stroke: "green" },
  soft126: { fill: "transparent", stroke: "green" },
  soft127: { fill: "transparent", stroke: "green" },
  soft128: { fill: "transparent", stroke: "green" },
  soft129: { fill: "transparent", stroke: "green" },
  soft130: { fill: "transparent", stroke: "green" },
  soft131: { fill: "transparent", stroke: "green" },
  soft132: { fill: "transparent", stroke: "green" },
  soft133: { fill: "transparent", stroke: "green" },
  soft134: { fill: "transparent", stroke: "green" },
  soft135: { fill: "transparent", stroke: "green" },
  soft136: { fill: "transparent", stroke: "green" },
  soft137: { fill: "transparent", stroke: "green" },
  soft138: { fill: "transparent", stroke: "green" },
  soft139: { fill: "transparent", stroke: "green" },
  soft140: { fill: "transparent", stroke: "green" },
  soft141: { fill: "transparent", stroke: "green" },
  soft142: { fill: "transparent", stroke: "green" },
  soft143: { fill: "transparent", stroke: "green" },
  soft144: { fill: "transparent", stroke: "green" },
  soft145: { fill: "transparent", stroke: "green" },
  soft146: { fill: "transparent", stroke: "green" },
  soft147: { fill: "transparent", stroke: "green" },
  soft148: { fill: "transparent", stroke: "green" },
  soft149: { fill: "transparent", stroke: "green" },
  soft150: { fill: "transparent", stroke: "green" },
};
